import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const HasWifi = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.25 17.5L13.25 13.5C12.4167 12.875 11.375 12.5 10.25 12.5C9.125 12.5 8.08333 12.875 7.25 13.5L10.25 17.5ZM10.25 2.5C6.875 2.5 3.75833 3.61667 1.25 5.5L2.75 7.5C4.83333 5.93333 7.43333 5 10.25 5C13.0667 5 15.6667 5.93333 17.75 7.5L19.25 5.5C16.7417 3.61667 13.625 2.5 10.25 2.5ZM10.25 7.5C8 7.5 5.925 8.24167 4.25 9.5L5.75 11.5C7 10.5583 8.55833 10 10.25 10C11.9417 10 13.5 10.5583 14.75 11.5L16.25 9.5C14.575 8.24167 12.5 7.5 10.25 7.5Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default HasWifi;
